import { all } from "redux-saga/effects";
import * as watchers from "./watchers";

export function* settingsSagas() {
  yield all([
    watchers.watchDeleteOrganization(),
    watchers.watchFetchInitialData(),
    watchers.watchPatchSettings(),
    watchers.watchPatchImportsSettings(),
    watchers.watchRequestAllUserData(),
    watchers.watchRequestAllAssessmentData(),
    watchers.watchRefreshSettings(),
    watchers.watchFetchOrganizationPreview(),
    watchers.watchCreateNewOrganization(),
    watchers.watchGetOrgInfo(),
    watchers.watchDeleteOrganizationFromPreview(),
  ]);
}
